<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-20 14:49:21
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-12 19:54:09
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\colonelActivitySquare\list\compoments\ksTab.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-table class="table-small" header-row-class-name="table-header-row" row-class-name="table-row" :data="list" ref="multipleTable">
			<el-table-column label="活动信息" min-width="190">
				<template slot-scope="{ row }">
					<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.activityTitle">
						<p class="yx-color-text-primary font-h6-medium" style="width: 100%">{{ row.activityTitle }}</p>
					</el-tooltip>
					<p class="yx-color-text-regular font-h6-regular">
						<span>ID：{{ row.activityId }}</span>
						<i class="el-icon-copy-document cursor-pointer hover ml-4 mt-2" @click="handleCopy(row.activityId)"></i>
					</p>
				</template>
			</el-table-column>
			<el-table-column label="招商类型" min-width="110">
				<template slot-scope="{ row }">
					<plainTag :type="row.activityType === 1 ? 'default' : 'primary'">
						{{ row.activityType === 1 ? '普通招商' : '专属招商' }}
					</plainTag>
				</template>
			</el-table-column>
			<el-table-column label="活动报名状态" min-width="110">
				<template slot-scope="{ row }">
					<rdStatus :type="statusConfig(row).type"> {{ statusConfig(row).label }} </rdStatus>
				</template>
			</el-table-column>
			<el-table-column label="报名数" min-width="110">
				<template slot-scope="{ row }">
					<p>{{ row.activityItemDataView && row.activityItemDataView.applyItemCount }}</p>
				</template>
			</el-table-column>
			<el-table-column label="通过数" min-width="110">
				<template slot-scope="{ row }">
					<p>{{ row.activityItemDataView && row.activityItemDataView.auditPassItemCount }}</p>
				</template>
			</el-table-column>
			<el-table-column label="操作" prop="operates" min-width="100" align="right">
				<template slot-scope="{ row }">
					<div>
						<el-button class="font-h6-regular" @click="goOn(row, '0')" type="text">继续报名</el-button>
					</div>
					<div>
						<el-button class="font-h6-regular" @click="goOn(row, '1')" type="text">查看报名商品</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
import { copy } from '@/utils/common';
import plainTag from '@/components/ui/plainTag';
import rdStatus from '@/components/ui/rdStatus';
import { PLATFORM_KS } from '@/utils/dataMap';
export default {
	components: {
		plainTag,
		rdStatus,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		goOn({ activityId, authorityId }, signUp) {
			let handLink = this.$router.resolve({
				path: '/secondColonelManage/colonelActivitySquare/detail',
				query: {
					id: activityId,
					signUp,
					platformId: PLATFORM_KS.value,
					authority_id: authorityId,
				},
			});
			window.open(handLink.href, '_blank');
		},
		statusConfig({ activityStatus }) {
			const status = {
				1: {
					label: '未发布',
					type: 'warning',
				},
				2: {
					label: '已发布',
					type: 'success',
				},
				3: {
					label: '进行中',
					type: 'success',
				},
				4: {
					label: '失效',
					type: 'fail',
				},
				5: {
					label: '已删除',
					type: 'error',
				},
			};
			return status[activityStatus] || {};
		},
	},
};
</script>
<style lang="less" scoped>
</style>